import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { ORDERS_GET_MANY, ORDERS_SEARCH_HINTS } from 'api/query-keys.ts';
import type { TOrderRes } from 'api/swagger';
import { PAGINATION_DEFAULT_LIMIT } from 'shared/constants/paginations';
import type { IOrdersFilter } from 'shared/stores';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs.ts';
import type { WithPagination } from 'shared/utils/pagination.ts';
import { preparePagination } from 'shared/utils/pagination.ts';
import type { IWithPagination } from 'types/api-query.ts';

interface IParams extends IWithPagination {
  search?: string;
  filters?: IOrdersFilter;
  isHints?: boolean;
  isSkip?: boolean;
}

export const useGetManyOrders = (params?: IParams) => {
  const { limit = PAGINATION_DEFAULT_LIMIT, page = 1, search, filters, isHints = false, isSkip = false } = params || {};

  const qs = new URLSearchParams({ limit: String(limit), page: String(page) });
  if (search) qs.set('filter[search]', search);
  if (filters) setFiltersToQs<IOrdersFilter>(qs, filters);

  return useQuery<WithPagination<TOrderRes[]>>({
    queryKey: isHints ? [ORDERS_SEARCH_HINTS, search] : [ORDERS_GET_MANY, page, limit, qs.toString()],
    queryFn: async () => {
      const { data, headers } = await http.get<TOrderRes[]>(`/v1/orders?${qs.toString()}`);
      const pagination = preparePagination(headers);

      return { data, pagination };
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true, //!(search || (filters && Object.keys(filters).length)),
    staleTime: 0,
    cacheTime: 0,
    enabled: !isSkip,
  });
};
